import { Tabs, TabsContent, TabsList, TabsTrigger } from '@atrvd/saas-ui'
import type { CrossCheckingTab } from '@/types/banking'
import type { ReactNode } from 'react'

interface TransactionMatchingTabsProps {
  activeTab: CrossCheckingTab
  onTabChange: (tab: CrossCheckingTab) => void
  children: {
    matching: ReactNode
    intactBalanceReport: ReactNode
    history: ReactNode
  }
}

/**
 * Tab navigation for cross-checking transaction matching
 * Shows three tabs: Matching, Intact Balance Report, and History
 */
export function TransactionMatchingTabs({
  activeTab,
  onTabChange,
  children,
}: TransactionMatchingTabsProps) {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold">Transactions Matching Status</h2>
      <Tabs value={activeTab} onValueChange={(value) => onTabChange(value as CrossCheckingTab)}>
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="matching">Matching</TabsTrigger>
          <TabsTrigger value="intact-balance-report">
            Intacct Balance Report
          </TabsTrigger>
          <TabsTrigger value="history">
            Matching and cross-checking History
          </TabsTrigger>
        </TabsList>

      <TabsContent value="matching" className="mt-6">
        {children.matching}
      </TabsContent>

      <TabsContent value="intact-balance-report" className="mt-6">
        {children.intactBalanceReport}
      </TabsContent>

      <TabsContent value="history" className="mt-6">
        {children.history}
      </TabsContent>
    </Tabs>
    </div>
  )
}